import React from 'react'
import {Typography,Button, Grid} from '@mui/material';
import colors from '../../../../colors'
import { useNavigate } from 'react-router';
import { makeStyles } from '@mui/styles';

const SingleUtility = (props) => 
{
    const state = {
        publicName: props.publicName,
        serviceName: props.serviceName,
        image: props.image,
        color: props.color
    }
   
    const navigate = useNavigate();

    const useStyles = makeStyles({
        button:{
            background:colors.white,
            color:colors.white,
            "&:hover":{backgroundColor:colors.white}
        },
        imageGrid:{
            background:colors.cyan,
            width:'100px',
            height:'100px',
            borderRadius:'15px',
            "&:hover":{backgroundColor:colors.utilityColor}
        },
        utilityName:{
            color:colors.darkBlue,
            fontSize:'0.9rem',
            fontFamily:'GerberaLight',
            textTransform:'none'
        }
    })

    const classes = useStyles()

    return(
        <Grid container justifyContent={'center'} mt={2} >
            <Button className={classes.button} onClick={props.onClick} >
                <Grid container justifyItems={'center'} flexDirection={'column'} alignItems={'center'} rowGap={2} >
                    <Grid container item justifyContent={'center'} alignContent={'center'} flexDirection={'column'} className={classes.imageGrid} >
                        <img src={state.image} style={{maxWidth:'70%', maxHeight:'60%'}}/>
                    </Grid>
                    <Grid container item justifyContent={'center'}>
                        <Typography className={classes.utilityName}>{state.publicName}</Typography>
                    </Grid>
                </Grid>
            </Button>
        </Grid>
    )
}
export default SingleUtility

